/* eslint-disable */
const initialState = {
  isOpen: true,
};
const TOGGLE = 'scratch-gui/cmra-curriculum/TOGGLE';

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
      case TOGGLE:
        return {...state, isOpen: action.payload};
    default:
        return state;
    }
};

const openCurriculumPanel = function () {
  return dispatch => { dispatch({ type: TOGGLE, payload: true }); }
}
const closeCurriculumPanel = function () {
  return dispatch => { dispatch({ type: TOGGLE, payload: false }); }
}

export {
  reducer as default,
  openCurriculumPanel,
  closeCurriculumPanel,
};
